module.exports = __webpack_public_path__ + "media/images/pages/peel/peel-2-1abaadb586c2eabf0064c01b24bbefe4.png";